'use client';

import { useState } from 'react';
import { track } from '@/lib/analytics/events';
import { xorHexDecode } from './decoder';

// hello@bunkersuite.com encoded with key "K1"
const CIPHER = '2354275d24712944255a2e43384422452e1f285e26';
const KEY = 'K1';

export default function ContactEmail({ label = 'Show email' }: { label?: string }) {
  const [addr, setAddr] = useState<string | null>(null);
  const reveal = () => {
    setAddr(xorHexDecode(CIPHER, KEY));
    track.cta({ cta_id: 'reveal_email', cta_text: 'show_email', section_id: 'contact', section_title: 'Contact' });
  };
  return addr ? (
    <a href={`mailto:${addr}`} data-nosnippet aria-label='Email us'>
      {addr}
    </a>
  ) : (
    <button type='button' onClick={reveal} data-nosnippet aria-label='Reveal email' className='cursor-pointer'>
      {label}
    </button>
  );
}
